module.exports = __webpack_public_path__ + "static/media/OutgoingIncomingBackground.5953272a.png";